module.exports = __webpack_public_path__ + "img/full7-min.b79a89dd.png";